module.exports = __webpack_public_path__ + "media/images/lb/407-43539afa939e004ef459e779475df003.svg";